import dxForm from 'devextreme/ui/form';
import { getItemOptions, setEditorOptions } from '#/common/components/Form/formItemOption';

/**
 * Handles user-picker field behaviour when the assetId changes on a form.
 *
 * Rules:
 * - If the field currently holds the logged-in user's own ID → keep it (don't clear).
 * - If the field holds a different user's ID (or is empty) → clear it.
 * - Always updates the `accessTo` constraint to match the new asset.
 *
 * @param form        - The DevExtreme form instance.
 * @param fieldName   - The user-picker field name (e.g. 'reportedById', 'assignedToId').
 * @param newAssetId  - The newly selected asset ID (undefined/null when asset is cleared).
 * @param currentUserId - The logged-in user's ID from useSession().
 */
export function handleUserFieldOnAssetChange(
  form: dxForm,
  fieldName: string,
  newAssetId: string | null | undefined,
  currentUserId: string | undefined,
): void {
  const currentFieldValue = (form.option('formData') as Record<string, unknown>)?.[fieldName] as
    | string
    | null
    | undefined;

  const isCurrentUser = currentFieldValue === currentUserId;
  const isEmpty = !currentFieldValue;

  if (!isEmpty && !isCurrentUser) {
    form.updateData(fieldName, null);
  }

  // Always update accessTo so the dropdown filters to the new asset's users.
  // This causes a brief flicker for the current user but ensures correctness.
  setEditorOptions(form, fieldName, {
    dataStoreOptions: {
      ...getItemOptions(form, fieldName)?.editorOptions?.dataStoreOptions,
      accessTo: newAssetId ? { resource: 'assets', ids: [newAssetId] } : undefined,
    },
  });
}
